import {Box, Divider} from '@mui/material';
import React, {useEffect} from 'react';
import {useGetMedicalConsentOptionsQuery} from '../../../../api/services/lookupsService';
import {
    useGetProfileDescriptionsQuery,
    useUpdateProfileDescriptionMutation
} from '../../../../api/services/schoolManagementService';
import useNotification from '../../../../utility/hooks/useNotification';
import {DEFAULT_PROFILE_SECTIONS_DESCRIPTIONS, PROFILE_SECTIONS_KEYS} from '../../../../constants/ProfileSectionsKeys';
import MedicalConsentSettings from './MedicalConsentSettings';
import AdmissionCategorySettings from './AdmissionCategorySettings';
import MedicineListSettings from './MedicineListSettings';
import WelfareSettings from './WelfareSettings';

const AdmicityLookups = () => {
    const {data: medicalConsentOptions = {options: []},} = useGetMedicalConsentOptionsQuery();
    const {
        data: descriptionData = [],
        isError: isLoadingDescriptionsFailed
    } = useGetProfileDescriptionsQuery();
    const [updateProfileDescription, {isError: isUpdateProfileDescriptionError}] = useUpdateProfileDescriptionMutation();
    const {showErrorNotification} = useNotification();

    useEffect(() => {
        if (isUpdateProfileDescriptionError) {
            showErrorNotification('Failed to update description');
        }

        if (isLoadingDescriptionsFailed) {
            showErrorNotification('Failed to load profile descriptions');
        }
    }, [isUpdateProfileDescriptionError, isLoadingDescriptionsFailed]);

    const descriptionOf = key => descriptionData.find(x => x.key === key)?.value ??
        DEFAULT_PROFILE_SECTIONS_DESCRIPTIONS[key];

    const handleDescriptionChange = async (key, value) => {
        await updateProfileDescription({key, value});
    };

    return (
        <Box
            display="flex"
            flexDirection="column"
            sx={{
                pt: 2,
                width: '100%',
            }}
            gap={1}
        >
            <MedicalConsentSettings
                medicalConsentOptions={medicalConsentOptions}
                title={descriptionData
                    .find(x => x.key === PROFILE_SECTIONS_KEYS.otcMedicationTitle)
                    ?.value ?? DEFAULT_PROFILE_SECTIONS_DESCRIPTIONS[PROFILE_SECTIONS_KEYS.otcMedicationTitle]
                }
                description={descriptionData
                    .find(x => x.key === PROFILE_SECTIONS_KEYS.otcMedication)
                    ?.value ?? DEFAULT_PROFILE_SECTIONS_DESCRIPTIONS[PROFILE_SECTIONS_KEYS.otcMedication]
                }
                onTitleChange={value => handleDescriptionChange(PROFILE_SECTIONS_KEYS.otcMedicationTitle, value)}
                onDescriptionChange={value => handleDescriptionChange(PROFILE_SECTIONS_KEYS.otcMedication, value)}
            />
            <Divider sx={{my: 1}}/>
            <AdmissionCategorySettings/>
            <Divider sx={{my: 1}}/>
            <MedicineListSettings
                sectionDescription={descriptionOf(PROFILE_SECTIONS_KEYS.medicineAtSchool)}
                onSectionDescriptionChange={value => handleDescriptionChange(PROFILE_SECTIONS_KEYS.medicineAtSchool, value)}
            />
            <Divider sx={{my: 1}}/>
            <WelfareSettings
                description={descriptionOf(PROFILE_SECTIONS_KEYS.welfare)}
                onDescriptionChange={value => handleDescriptionChange(PROFILE_SECTIONS_KEYS.welfare, value)}
            />
        </Box>
    );
};

export default AdmicityLookups;
